/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconClear, IconClock, IconClockCountDown, IconDeletePolls, IconDotsHorizontal, IconEditPolls } from '../../../base/icons/svg';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
import Button from '../../../base/ui/components/web/Button';
import Checkbox from '../../../base/ui/components/web/Checkbox';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import AbstractPollAnswer from '../AbstractPollAnswer';
import { FormControlLabel, InputAdornment, Popover, Radio, RadioGroup, TextField } from '@mui/material';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import DotContent from './DotContent';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { TYPE } from './constant';
import { getLocalParticipant, getRemoteParticipants, getUserIdByOccupantId } from '../../../base/participants';
import moment from 'moment';
import { cloneDeep, uniq, uniqBy } from 'lodash';
import { openDialog } from '../../../base/dialog/actions';
import DetailPollDialog from './DetailPollDialog';
import ConfirmDialog from '../../../base/dialog/components/web/ConfirmDialog';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            margin: '16px',
            padding: '18px 12px',
            backgroundColor: theme.palette.white,
            borderRadius: '8px',
            border: `1px solid ${theme.palette.grey01}`,
            wordBreak: 'break-word'
        },
        closeBtn: {
            cursor: 'pointer',
            float: 'right'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        question: {
            ...withPixelLineHeight(theme.typography.heading6),
            color: theme.palette.grey01,
            marginBottom: '8px'
        },
        creator: {
            ...withPixelLineHeight(theme.typography.bodyShortRegular),
            color: theme.palette.grey02,
            marginBottom: '8px',
            fontSize: '12px'
        },
        answerList: {
            listStyleType: 'none',
            margin: 0,
            padding: 0,
            marginBottom: '24px'
        },
        answer: {
            display: 'flex',
            '& div:nth-child(2)': {
                color: theme.palette.grey01
            }
        },
        footer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        buttonMargin: {
            marginRight: theme.spacing(3)
        },
        button: {
            cursor: 'pointer'
        },
        textCounterTime: {
            color: theme.palette.grey01,
            fontSize: '14px',
            fontWeight: '600',
            marginLeft: '3px'
        },
        particpantVoted: {
            color: theme.palette.primary10,
            fontSize: '12px',
            '&:hover': {
                textDecoration: 'underline',
                cursor: 'pointer'
            }
        },
        fullWidth: {
            width: '100%'
        },
        barContainer: {
            backgroundColor: theme.palette.grey05,
            borderRadius: '4px',
            height: '6px',
            width: '100%',
            marginTop: '6px',
            marginBottom: '10px',
            display: 'block'
        },
        bar: {
            height: '6px',
            borderRadius: '4px',
            backgroundColor: theme.palette.redP03
        }
    };
});
const IconRemove = () => {
    return (React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5 3.82107L8.53553 0.285534L9.71405 1.46405L6.17851 4.99958L9.71405 8.53511L8.53553 9.71362L5 6.17809L1.46447 9.71362L0.285955 8.53511L3.82149 4.99958L0.285955 1.46405L1.46447 0.285534L5 3.82107Z", fill: "#8F9294" })));
};
const MAX_ADD_MORE_OPTION = 10;
const PollAnswer = ({ creatorName, checkBoxStates, poll, pollId, setCheckbox, setCreateMode, skipAnswer, skipChangeVote, sendPoll, submitAnswer, _answers, redirectFormAddOption, optionValue, setOptionValue, addOption, cancelAddOption, deletePoll, editPollHandle, endPoll, removeMyAnswer, disabled, validateMaxLength, setValidateMaxLength }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const { classes } = useStyles();
    const [checkEmpty, setCheckEmpty] = useState(true);
    const [isActiveVote, setIsActiveVote] = useState(false);
    const userId = useSelector((state) => getUserIdByOccupantId(state, poll?.senderId));
    const [timeCounter, setTimeCounter] = useState(-1);
    const [pollAnswersConvert, setPollAnswersConvert] = useState([]);
    const [avatarSet, setAvatarSet] = useState([]);
    const [isIdenticalAnswer, setIsIdenticalAnswer] = useState(false);
    const localParticipant = getLocalParticipant(APP.store.getState());
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleAddOptions = () => {
        redirectFormAddOption();
    };
    const handleDetelePoll = () => {
        handleClose();
        dispatch(openDialog(ConfirmDialog, {
            hideTooltip: true,
            titleKey: 'polls.delete.title',
            onSubmit: () => deletePoll(poll?.pollId),
            children: React.createElement("p", null,
                t('polls.delete.content1'),
                " ",
                React.createElement("span", { style: { fontWeight: '600' } }, `${poll.question}`),
                " ",
                t('polls.delete.content2')),
            ok: {
                translationKey: 'polls.delete.deletPoll'
            }
        }));
        // if(!checkEmpty) {
        //     dispatch(
        //         showNotification(
        //             {
        //                 descriptionKey: "notify.deleteFail",
        //                 titleKey: t("notify.deleteContent"),
        //             },
        //             NOTIFICATION_TIMEOUT_TYPE.LONG
        //         )
        //     );
        // }
    };
    const handleEndPoll = (pollId, isUpdate = false) => {
        endPoll(pollId);
        handleClose();
    };
    let counterTimeIntervalID;
    let counterTimeLeftId;
    function convertSecondsToHHMMSS(totalSeconds) {
        if (totalSeconds <= 0) {
            clearInterval(counterTimeIntervalID);
            return '00:00:00';
        }
        let hours = Math.floor(totalSeconds / 3600);
        let minutes = Math.floor((totalSeconds % 3600) / 60);
        let seconds = totalSeconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    function calculateParticipantVoted() {
        let idUserVotedArray = [];
        for (let i = 0; i < poll.answers.length; i++) {
            if (poll.answers[i].voters instanceof Map) {
                for (let key of poll.answers[i].voters.keys()) {
                    idUserVotedArray.push(key);
                }
            }
        }
        idUserVotedArray = uniq(idUserVotedArray);
        return idUserVotedArray.length;
    }
    useEffect(() => {
        if (poll.status === TYPE.STARTED && poll.duration >= 0) {
            const timeEndCounter = moment(poll.startTime).clone().add(poll.duration, 's').unix();
            const timeStartCounter = moment().clone().unix();
            setTimeCounter(timeEndCounter - timeStartCounter);
            counterTimeLeftId = setTimeout(() => {
                handleEndPoll(pollId);
            }, (timeEndCounter - timeStartCounter) * 1000 + 3000);
            counterTimeIntervalID = setInterval(() => {
                setTimeCounter((prev) => prev - 1);
            }, 1000);
        }
    }, [poll.status]);
    useEffect(() => {
        if (timeCounter === 0 && (poll?.duration && poll?.duration >= 0) && poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id) {
            handleEndPoll(pollId);
            clearTimeout(counterTimeLeftId);
        }
    }, [timeCounter]);
    useEffect(() => {
        setCheckEmpty(poll?.answers.every((answer) => answer.voters.size === 0));
    }, [poll]);
    useEffect(() => {
        const participants = [...getRemoteParticipants(APP.store.getState()).values()];
        const remoteParticipants = APP.store.getState()["features/filmstrip"].remoteParticipants;
        if (participants.length > 0) {
            const dataRemoteParticipants = participants[0]?.conference?.participants;
            const dataConverted = remoteParticipants.map((p) => {
                const uid = dataRemoteParticipants.get(p)?._identity?.user?.id;
                const uname = dataRemoteParticipants.get(p)?._displayName;
                const isParticipant = participants.find(part => part.id === p);
                const loadableAvatarUrl = isParticipant?.loadableAvatarUrl;
                return {
                    uid,
                    uname,
                    loadableAvatarUrl
                };
            });
            setPollAnswersConvert(poll.answers.map((answer) => {
                const p = cloneDeep(answer);
                if (p.voters.size > 0) {
                    let dataReturn = [];
                    for (const [key, value] of p.voters.entries()) {
                        const isParticipant = dataConverted.find((d) => d.uid === key);
                        if (isParticipant) {
                            dataReturn.push({
                                nameAns: p.name,
                                uid: key,
                                uname: isParticipant.uname,
                                loadableAvatarUrl: isParticipant.loadableAvatarUrl
                            });
                        }
                        else {
                            dataReturn.push({
                                nameAns: p.name,
                                uid: key,
                                uname: localParticipant?.name,
                                loadableAvatarUrl: localParticipant?.name === value ? localParticipant?.loadableAvatarUrl : localParticipant?.loadableAvatarUrl
                            });
                        }
                    }
                    p.voters = dataReturn;
                }
                return p;
            }));
        }
        else {
            setPollAnswersConvert(poll.answers.map((answer) => {
                const p = cloneDeep(answer);
                if (p.voters.size > 0) {
                    let dataReturn = [];
                    // for (let key of p.voters.keys()) {
                    for (const [key, value] of p.voters.entries()) {
                        dataReturn.push({
                            nameAns: p.name,
                            uid: key,
                            uname: value,
                            loadableAvatarUrl: localParticipant?.name === value ? localParticipant?.loadableAvatarUrl : undefined
                        });
                    }
                    p.voters = dataReturn;
                }
                return p;
            }));
        }
    }, [poll]);
    useEffect(() => {
        const newSet = [];
        pollAnswersConvert?.map((p) => (p.voters?.length > 0 && (p.voters?.map((u) => (newSet.push({
            id: u.uid,
            name: u.uname,
            avatarUrl: u.loadableAvatarUrl
        }))))));
        setAvatarSet(uniqBy(newSet, 'id'));
    }, [pollAnswersConvert]);
    useEffect(() => {
        if (optionValue.trim().length > 255) {
            setValidateMaxLength(true);
        }
        else
            setValidateMaxLength(false);
        setIsIdenticalAnswer(poll.answers.length === 0 ? false
            : poll.answers.some((prevAnswer) => prevAnswer.name === optionValue
                && prevAnswer.name !== '' && optionValue !== ''));
    }, [optionValue]);
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.header },
            React.createElement("div", { className: classes.question }, poll.question),
            React.createElement("div", { style: { minWidth: '24px', display: 'flex', justifyContent: 'end' } }, poll.status === TYPE.NOT_START
                ?
                    (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: classes.button, onClick: () => {
                                editPollHandle();
                            } },
                            React.createElement(Tooltip, { content: t(`polls.answer.edit`), position: "top" },
                                React.createElement(IconEditPolls, { height: 20, width: 18 }))),
                        React.createElement("span", { className: classes.button, style: { marginLeft: '12px' }, onClick: () => handleDetelePoll() },
                            React.createElement(Tooltip, { content: t(`polls.answer.remove`), position: "top" },
                                React.createElement(IconDeletePolls, { height: 20, width: 18 })))))
                :
                    (React.createElement(React.Fragment, null,
                        React.createElement(Icon, { style: { cursor: 'pointer' }, size: 24, src: IconDotsHorizontal, onClick: handleClick }),
                        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                                vertical: 'center',
                                horizontal: 'left'
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            } },
                            React.createElement(DotContent, { poll: poll, pollId: pollId, answers: _answers, handleClose: handleClose, skipChangeVote: skipChangeVote, skipAnswer: skipAnswer, checkEmpty: checkEmpty, handleEndPoll: handleEndPoll, handleDetelePoll: handleDetelePoll, changeVote: () => { }, removeMyAnswer: removeMyAnswer })))))),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', height: '24px', justifyContent: 'space-between' } },
            React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(Tooltip, { content: poll.status === TYPE.STARTED ? t("polls.timeVote") : t("polls.timeEnd") },
                    React.createElement(Icon, { className: "action-icon attachIcon", size: 20, src: poll.status === TYPE.STARTED ? IconClockCountDown : IconClock })),
                React.createElement("div", { className: classes.textCounterTime }, poll.status === TYPE.NOT_START
                    ?
                        poll.duration === -1
                            ?
                                t('polls.unlimited')
                            :
                                convertSecondsToHHMMSS(poll.duration)
                    :
                        poll.status === TYPE.STARTED
                            ?
                                poll.duration === -1
                                    ?
                                        t('polls.unlimited')
                                    :
                                        convertSecondsToHHMMSS(timeCounter)
                            :
                                moment(poll?.end_time).format("HH:mm, DD-MM-YYYY"))),
            React.createElement("div", { className: classes.particpantVoted, onClick: () => {
                    dispatch(openDialog(DetailPollDialog, {
                        answers: poll.answers,
                        poll: poll
                    }));
                } }, t("polls.participantVoted", { number: calculateParticipantVoted() }))),
        React.createElement("div", { className: classes.creator },
            t('polls.by'),
            " ",
            React.createElement("span", { style: { fontWeight: '600' } }, creatorName),
            " ",
            userId == JSON.parse(`${localStorage.getItem("user")}`)["id"] && t("polls.you")),
        React.createElement("ul", { className: classes.answerList },
            poll.chooseMultipleOptions &&
                pollAnswersConvert.map((answer, index) => (React.createElement("li", { className: classes.answer, key: index },
                    React.createElement(Checkbox, { checked: checkBoxStates[index], disabled: disabled || poll.status === TYPE.NOT_START || poll?.isAddOption, key: index, styleLabelFullWidth: true, alignItemsStart: true, label: React.createElement("div", { style: { display: 'flex', flexDirection: 'column', marginTop: '4px' } },
                            React.createElement("div", { style: { display: 'flex', alignItems: 'end', justifyContent: 'space-between' } },
                                React.createElement("div", { style: { fontSize: '14px', fontWeight: '500' } }, answer.name),
                                React.createElement("div", { style: { minWidth: 'fit-content', fontSize: '14px' } },
                                    React.createElement("span", { style: { fontWeight: '600', margin: "0 4px" } }, answer.voters.length || 0),
                                    `(${answer.voters.length ? (Math.round((answer.voters.length / avatarSet.length) * 100)) : 0}%)`)),
                            React.createElement("span", { className: classes.barContainer },
                                React.createElement("div", { className: classes.bar, style: { width: `${answer.voters.length ? (Math.round((answer.voters.length / avatarSet.length) * 100)) : 0}%` } }))), onChange: ev => setCheckbox(index, ev.target.checked) })))),
            !poll.chooseMultipleOptions &&
                React.createElement(RadioGroup, { "aria-labelledby": "radio-buttons-group-label", defaultValue: "female", name: "radio-buttons-group" }, pollAnswersConvert.map((answer, index) => (React.createElement(FormControlLabel, { sx: {
                        '&': {
                            alignItems: 'flex-start',
                            marginRight: '0px !important'
                        },
                        '& .MuiFormControlLabel-label': {
                            whiteSpace: 'normal !important',
                            fontWeight: '400',
                            color: '#44494D !important',
                            width: '100%'
                        }
                    }, value: "default radio", control: React.createElement(Radio, { key: index, disabled: disabled || poll.status === TYPE.NOT_START || poll?.isAddOption, checked: checkBoxStates[index] || false, onChange: (event) => {
                            setCheckbox(index, event.target.checked);
                        } }), label: React.createElement("div", { style: { display: 'flex', flexDirection: 'column', marginTop: '9px' } },
                        React.createElement("div", { style: { display: 'flex', alignItems: 'end', justifyContent: 'space-between' } },
                            React.createElement("div", { style: { fontSize: '14px', fontWeight: '500' } }, answer.name),
                            React.createElement("div", { style: { minWidth: 'fit-content', fontSize: '14px' } },
                                React.createElement("span", { style: { fontWeight: '600', margin: "0 4px" } }, answer.voters.length || 0),
                                `(${answer.voters.length ? (Math.round((answer.voters.length / avatarSet.length) * 100)) : 0}%)`)),
                        React.createElement("span", { className: classes.barContainer },
                            React.createElement("div", { className: classes.bar, style: { width: `${answer.voters.length ? (Math.round((answer.voters.length / avatarSet.length) * 100)) : 0}%` } }))) })))),
            !disabled && poll?.isAddOption && (React.createElement("div", { style: { marginTop: '10px' } },
                React.createElement(FormControlLabel, { id: 'polls-create-input', label: "", labelPlacement: 'top', control: React.createElement(TextField, { placeholder: t('polls.create.answerPlaceholder'), size: "small", fullWidth: true, sx: {
                            '& > .MuiInputBase-root': { padding: '0 8px 0 0' },
                            '& .MuiInputBase-root': {
                                '& ::placeholder': {
                                    color: '#73777A',
                                    opacity: '1'
                                },
                                '& .MuiInputBase-input': {
                                    padding: '4.5px 0.875em',
                                    fontSize: '14px',
                                }
                            }
                        }, error: validateMaxLength || isIdenticalAnswer, helperText: (validateMaxLength && t('polls.errors.overLength') || (isIdenticalAnswer && t('polls.errors.notUniqueOption'))), autoFocus: true, value: optionValue, onChange: e => setOptionValue(e.target.value), 
                        // error={validate}
                        InputProps: {
                            endAdornment: (React.createElement(InputAdornment, { position: "end" }, optionValue.length > 0 ? (React.createElement(Tooltip, { content: t('textField.clear') },
                                React.createElement(ClickableIcon, { accessibilityLabel: "close", icon: IconClear, onClick: () => {
                                        setOptionValue('');
                                    } }))) : (React.createElement(React.Fragment, null)))),
                        } }) })))),
        React.createElement("div", { className: classes.footer }, poll.status === TYPE.NOT_START
            ?
                React.createElement(React.Fragment, null,
                    React.createElement(Button, { size: 'smallMedium', className: classes.fullWidth, labelKey: 'polls.answer.send', onClick: sendPoll }))
            :
                (poll?.status === TYPE.STARTED && poll?.isAddOption)
                    ?
                        React.createElement(React.Fragment, null,
                            React.createElement(Button, { size: 'smallMedium', className: classes.buttonMargin, labelKey: 'polls.answer.cancel', onClick: cancelAddOption, type: BUTTON_TYPES.SECONDARY }),
                            React.createElement(Button, { accessibilityLabel: optionValue.trim().length === 0 && t('polls.errors.enterAnswer'), size: 'smallMedium', disabled: optionValue.trim().length === 0 || validateMaxLength || isIdenticalAnswer, labelKey: 'polls.answer.confirm', onClick: addOption }))
                    :
                        React.createElement(React.Fragment, null,
                            (poll?.canAddOption) && !disabled && poll.answers.length < 10 &&
                                React.createElement(Button, { size: 'smallMedium', disabled: poll?.answers.length > MAX_ADD_MORE_OPTION, labelKey: 'polls.answer.addMoreOptions', onClick: handleAddOptions, type: BUTTON_TYPES.SECONDARY, fullWidth: !checkBoxStates?.find((el) => el) }),
                            (checkBoxStates?.find((el) => el) || poll.status === TYPE.ENDED) &&
                                React.createElement(Button, { size: 'smallMedium', fullWidth: disabled || !poll?.canAddOption || poll.answers.length?.length >= 10, labelKey: 'polls.answer.viewResult', onClick: () => {
                                        dispatch(openDialog(DetailPollDialog, {
                                            answers: poll.answers,
                                            poll: poll
                                        }));
                                    }, type: BUTTON_TYPES.SECONDARY })))));
};
/*
 * We apply AbstractPollAnswer to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollAnswer(PollAnswer);
